

import AppFullscreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import {Bank} from "@/models/base";
import {ToolbarService, UserConfigService} from "@/services";
import Vue from "vue";
import AppBankInfoDefault from "./BankInfoDefault.vue";
import {Permissions} from "@/models/user-configs/permissions";

export default Vue.extend({
	data() {
		return {

		};
	},
	props: {
		bank: Object as () => Bank,
	},
	computed: {
		hasPermission():boolean {
			return UserConfigService.hasCurrentUserPermission((permissions:Permissions):boolean=>{
				return permissions.BankPermissions.hasWritePermissions();
			});
		}
	},

	methods: {
		cancel(){
			this.$router.push("/bank");
		},
		edit(){
			this.$router.push(`/bank/edit/${this.bank.ID}`);
		}
	},
	async mounted() {
		ToolbarService.title = this.$ct("titles.view");
	},
	components: {
		AppFullscreenContainer,
		AppToolbar,
		AppBankInfoDefault
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
